import { useApi } from '../composables/useApi'

const api = useApi()

export const departmentService = {
  // Get all departments
  getAll: async () => {
    try {
      const response = await api.get('/departments')
      return {
        success: true,
        data: response.data || []
      }
    } catch (error) {
      console.error('Error fetching departments:', error)
      return {
        success: false,
        message: error.message || 'Failed to fetch departments',
        data: []
      }
    }
  },

  // Get active departments only
  getActive: async () => {
    try {
      const response = await api.get('/departments?active=true')
      return {
        success: true,
        data: response.data || []
      }
    } catch (error) {
      console.error('Error fetching active departments:', error)
      return {
        success: false,
        message: error.message || 'Failed to fetch departments',
        data: []
      }
    }
  },

  // Get single department by ID
  getById: async (id) => {
    try {
      const response = await api.get(`/departments/${id}`)
      return {
        success: true,
        data: response.data
      }
    } catch (error) {
      console.error('Error fetching department:', error)
      return {
        success: false,
        message: error.message || 'Failed to fetch department'
      }
    }
  },

  // Create new department
  create: async (departmentData) => {
    try {
      const response = await api.post('/departments', departmentData)
      return {
        success: true,
        data: response.data,
        message: 'Department created successfully'
      }
    } catch (error) {
      console.error('Error creating department:', error)
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to create department',
        errors: error.response?.data?.errors || {}
      }
    }
  },

  // Update department
  update: async (id, departmentData) => {
    try {
      const response = await api.put(`/departments/${id}`, departmentData)
      return {
        success: true,
        data: response.data,
        message: 'Department updated successfully'
      }
    } catch (error) {
      console.error('Error updating department:', error)
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to update department',
        errors: error.response?.data?.errors || {}
      }
    }
  },

  // Delete department
  delete: async (id) => {
    try {
      await api.delete(`/departments/${id}`)
      return {
        success: true,
        message: 'Department deleted successfully'
      }
    } catch (error) {
      console.error('Error deleting department:', error)
      return {
        success: false,
        message: error.response?.data?.message || error.message || 'Failed to delete department'
      }
    }
  }
}

export default departmentService 